<!--
 * @Author: houmy
 * @Date: 2023-08-29 18:57:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-20 18:25:10
 * @FilePath: \zx-home\src\components\Footer.vue
 * @Description: 
 * 
-->
<template>
  <footer class="footer">
    <div class="footer-top flex-row">
      <div class="footer-top-left">
        <img src="../assets/img/logo-white.png" alt="">
        <p><span>电话：13974811172（微信同号）</span><span>邮箱：business@sforceauto.com</span></p>
        <p><span>地址：广东省佛山市顺德区陈村镇莱茵科技园3栋702</span></p>
      </div>
      <ul class="footer-top-right">
        <li>
          <b>
            <router-link to="/products" @click.native="refresh">产品中心<img src="../assets/img/right.png" alt=""></router-link>
          </b>
          <span>
            <router-link to="/products?type=1" @click.native="refresh">智能感知</router-link>
          </span>
          <span>
            <router-link to="/products?type=2" @click.native="refresh">智能驾驶</router-link>
          </span>
          <span>
            <router-link to="/products?type=3" @click.native="refresh">智能硬件</router-link>
          </span>
          <span>
            <router-link to="/products?type=4" @click.native="refresh">智慧云平台</router-link>
          </span>
        </li>
        <li>
          <b class="option-text">
            <router-link to="/solution"  @click.native="refresh">
              解决方案 <img src="../assets/img/right.png" alt="">
            </router-link></b>
          <span>
            <router-link to="/solutionDetail?id=1" @click.native="refresh">无人驾驶作业解决方案</router-link>
          </span>
          <span>
            <router-link to="/solutionDetail?id=2" @click.native="refresh">智慧农场解决方案</router-link>
          </span>

        </li>
        <li>
          <b><router-link to="/support" @click.native="refresh">服务支持 <img src="../assets/img/right.png" alt=""></router-link></b>
          <span>
            <router-link to="/support?type=1" @click.native="refresh">常见问题</router-link>
          </span>
          <span>
            <router-link to="/support?type=2" @click.native="refresh">视频中心</router-link>
          </span>
          <span>
            <router-link to="/support?type=3" @click.native="refresh"> 售后服务协议</router-link>
          </span>

        </li>
        <li>
          <b><router-link to="/about"  @click.native="refresh">关于我们 <img src="../assets/img/right.png" alt=""></router-link></b>
          <span>
            <router-link to="/about?anchor=1"  @click.native="refresh">公司介绍</router-link>
          </span>
          <span @click="handleShowContact">
            联系我们
          </span>
        </li>
      </ul>

    </div>
    <div class="footer-bottom">
      <p>专注于用智能科技改变生产方式，推动农业和施工作业向智能、安全、无人化快速发展</p>
      <p>Copyright © {{ currentYear }} 广东六力智行科技有限公司 粤ICP备2022109452号</p>
    </div>
    <div class="contactModel" v-show="showContact">
      <div class="contactTitle">
        <h3>联系我们</h3>
        <img class="cur-poi" @click="handleCloseContact" src="../assets/img/close.png" alt="">
      </div>
      <div class="contactModelMain">
        <ul class="flex-row">
          <li class="flex-col">
            <label>微信咨询</label>
            <img src="../assets/img/weixin.png" alt="">
          </li>
          <li class="flex-col">
            <label>关注我们</label>
            <img src="../assets/img/guanzhu.jpg" alt="">
          </li>
        </ul>
        <p>
          <span>联系我们：13974811172（微信同号）</span>
          <span>邮箱：raojy@sforceauto.com</span>
        </p>
        <p>公司地址：广东省佛山市顺德区陈村镇莱茵科技园3栋702</p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      showContact: false,
      currentYear: 2023
    };
  },
  mounted() {
    this.currentYear = new Date().getFullYear()
  },
  methods: {
    // 显示弹窗
    handleShowContact() {
      this.showContact = true
    },
    // 关闭弹窗
    handleCloseContact() {
      this.showContact = false
    },

    refresh() {
      this.$router.go(0)
    }
  }
};
</script>
<style scoped></style>
  


// WEBPACK FOOTER //
// src/components/Footer.vue